var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',{attrs:{"accept":_vm.type,"error-messages":_vm.error,"label":"Profile Image","dense":"","outlined":"","prepend-icon":""},on:{"change":function($event){return _vm.changeData($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }